import React, { useState, useEffect, useContext } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { toRelativeUrl } from "@okta/okta-auth-js";
import { Outlet } from "react-router-dom";
import { Spin } from "antd";
import { Layout } from "antd";
import Header from "./Header";
import Cookies from "js-cookie";
import Footer from "./Footer";
import { fetchUserByUserName } from "../services/users-service";
import UserContext from "../context/user-context";

const { Content } = Layout;

function RequiredAuth() {
  const { oktaAuth, authState } = useOktaAuth();
  const [roles, setRoles] = useState();
  const [userInfo, setUserInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [, setUser] = useContext(UserContext)

  const getUserByUserName = async (username) => {
    try {
      let response = await fetchUserByUserName(username);
      if (response.ok) {
        let data = await response.json();
        if (data != null) {
          setUser(data)
          setRoles(data?.roles?.map((role) => role?.roleName));
        }
      } else {
        setUser(null);
        setRoles([]);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!authState || !authState.isAuthenticated) {
      setUserInfo(null);
    } else {
      Cookies.set("accessToken", oktaAuth.getAccessToken(), { expires: 7 });
      oktaAuth.getUser().then((info) => {
        setUserInfo(info);
        Cookies.set("userInfoFromOkta", JSON.stringify(info), { expires: 7 });
        getUserByUserName(info?.preferred_username).catch((err) => {
          console.error("Failed to fetch user by username", err);
        });
      }).catch(() => {
        setIsLoading(false);
      });
    }
  }, [authState, oktaAuth]);

  useEffect(() => {
    if (!authState) {
      return;
    }
    if (!authState?.isAuthenticated) {
      const originalUri = toRelativeUrl(
        window.location.href,
        window.location.origin
      );
      oktaAuth.setOriginalUri(originalUri);
      oktaAuth.signInWithRedirect();
    }
  }, [oktaAuth, !!authState, authState?.isAuthenticated]);

  return (
    <Layout>
      {isLoading ? null : roles ? (
        <>
          <Header />
          <Layout>
            <Content>
              <Outlet />
            </Content>
          </Layout>
          <Footer />
        </>
      ) : (
        <div style={{ padding: "2rem", textAlign: "center" }}>
          <p>Unable to load user profile. Please contact your administrator.</p>
        </div>
      )}
    </Layout>
  );
}

export default RequiredAuth;